import Sider from '../layout/sider.vue';

export default Sider; 


// WEBPACK FOOTER //
// ./src/components/sider/index.js